<template>
  <!-- 登录弹框 -->
  <div class="user">
    <v-modal
      v-model="is"
      @on-cancel="cancel"
      :width="$i18n.locale === 'zh' ? 420 : 470"
      :styles="{top: '183px'}"
      :mask-closable="false">
      <p slot="header" class="login-header">
        <span>{{ type === 'login' ? $t('system.signin') : $t('system.resetPsd') }}</span>
      </p>
      <i slot="close" class="login-close-icon" style="line-height: 40px;">
        ×
      </i>
      <!-- 登录窗 -->
      <template v-if="type === 'login'">
        <div :class="['login-content', { 'login-content-en': $i18n.locale === 'zh' }]">
          <v-form ref="info" :model="info" :rules="infoRuleValidate" :label-width="$i18n.locale === 'zh' ? 60 : 90" label-position="right">
            <v-form-item class="iview-label" :label="$t('user.account')" prop="account">
              <v-input class="iview-input" v-model="info.account" size="large" :placeholder="$t('tip.input.smsEmail')"></v-input>
            </v-form-item>
            <v-form-item class="iview-label" :label="$t('user.password')" prop="password">
              <v-input class="iview-input" type="password" size="large" v-model="info.password" :placeholder="$t('tip.input.password')"></v-input>
            </v-form-item>
          </v-form>
          <p>
            <v-checkbox class="iview-checkbox" v-model="isCatch">
              {{ `&nbsp;&nbsp;${$t('system.remember')}` }}
            </v-checkbox>
            <span>
              <a href="javascript:void(0);" @click="toggle()">
                {{ $t('system.forgetPw') }}
              </a>
            </span>
          </p>
        </div>
        <div slot="footer" class="login-footer">
          <Button class="cd-btn" size="large" @click="formValidate('info', login)" :loading="showLoginLoading">
            {{ $t('system.signin') }}
          </Button>
          <p class="footer-tip">
            {{ $t('tip.account.not') }}
            <a href="javascript:void(0);" @click.stop="toRegister">
              {{ $t('system.register') }}
            </a>
          </p>
        </div>
      </template>
      <!-- 忘记密码窗 -->
      <template v-else>
        <div :class="['login-content', { 'login-content-en': $i18n.locale === 'zh' }]">
          <v-form ref="restInfo" :model="restInfo" :rules="restInfoRuleValidate" :label-width="$i18n.locale === 'zh' ? 60 : 90" label-position="right">
            <!-- 手机 -->
            <v-form-item class="iview-label" :label="$t('user.phone.mobile')" prop="account">
              <v-input class="iview-input" v-model="restInfo.account" size="large" :placeholder="$t('tip.input.phone')"></v-input>
            </v-form-item>
            <!-- 图形验证码 -->
            <v-form-item prop="imageCode">
              <v-input class="iview-input-code" size="large" v-model="restInfo.imageCode" :placeholder="$t('tip.input.code[0]')"></v-input>
              <img class="code-img" :src="imageCode" alt="验证码" @click.stop="getImageCode">
            </v-form-item>
            <!-- 手机验证码 -->
            <v-form-item :label="$t('system.code')" prop="phoneCode">
              <v-input class="iview-input-forget" size="large" v-model="restInfo.phoneCode" :placeholder="$t('tip.input.code[1]')"></v-input>
              <Button class="iview-input-forget-button cd-btn" :disabled="createTime > 0" @click="verifyImageCode">
                {{ $t('system.getCode') }}
                <template v-if="createTime">
                  ( {{ ((createTime - new Date().getTime()) / 1000).toFixed(0) }} )
                </template>
              </Button>
            </v-form-item>
            <!-- 新密码 -->
            <v-form-item :label="$t('user.newpassword')" prop="newPsd">
              <v-input class="iview-input" type="password" size="large" v-model="restInfo.newPsd" :placeholder="$t('tip.input.passwordLength')"></v-input>
            </v-form-item>
          </v-form>
        </div>
        <div slot="footer" class="login-footer-forget login-footer">
          <Button class="cd-btn" type="error" size="large" @click="formValidate('restInfo', phonePwd)">
          {{ $t('system.resetPsd') }}
          </Button>
        </div>
      </template>
    </v-modal>
  </div>
</template>

<script>
import {
  Modal, Form, FormItem, Input, Checkbox,
} from 'iview';
import md5 from 'blueimp-md5';

export default {
  name: 'login',
  components: {
    VModal: Modal,
    VForm: Form,
    VFormItem: FormItem,
    VInput: Input,
    VCheckbox: Checkbox,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    path: {
      type: String,
      default: 'login',
    },
    callBackRoute: {
      type: String,
      default: '',
    },
  },
  data() {
    const phoneAndMailValidate = {
      validator: (rule, value, callback) => {
        const isPhone = /^\d+$/.test(value) && (value.length === 8 || value.length === 11);
        const isMail = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value);
        if (isMail || isPhone) {
          callback();
          return;
        }
        callback(new Error(this.$t('tip.input.phoneOrEmail')));
      },
      trigger: 'blur',
    };
    return {
      showLoginLoading: false, // 控制是否显示按钮loading事件
      is: this.show, // 控制是否显示弹框
      isCatch: false, // 控制是否缓存账号密码
      type: this.path,
      createTime: '',
      imageCode: '',
      info: {
        account: '',
        password: '',
      },
      restInfo: {
        account: '',
        imageCode: '',
        phoneCode: '',
        newPsd: '',
      },
      infoRuleValidate: { // 登录表单验证规则
        account: [{
          required: true,
          message: this.$t('tip.input.account'),
          trigger: 'blur',
        }, phoneAndMailValidate],
        password: [{
          required: true,
          message: this.$t('tip.input.password'),
          trigger: 'blur',
        }, {
          type: 'string',
          min: 6,
          max: 16,
          message: this.$t('tip.psdLenghtAlert'),
          trigger: 'blur',
        }],
      },
      restInfoRuleValidate: { // 重置密码表单验证规则
        account: [{
          required: true,
          message: this.$t('tip.input.phoneNum'), // 必填
          trigger: 'blur',
        }, {
          validator: (rule, value, callback) => {
            if (/^\d+$/.test(value) && (value.length === 8 || value.length === 11)) {
              callback();
            } else {
              callback(new Error(this.$t('tip.input.phoneNum')));
            }
          },
          trigger: 'blur',
        }],
        imageCode: [{ // 图片验证码
          required: true,
          message: this.$t('tip.input.code[0]'), // 必填
          trigger: 'blur',
        }],
        phoneCode: [{ // 手机验证码
          required: true,
          message: this.$t('tip.input.code[0]'), // 必填
          trigger: 'blur',
        }],
        newPsd: [{ // 新密码
          required: true,
          message: this.$t('tip.input.password'), // 必填
          trigger: 'blur',
        }, {
          type: 'string',
          min: 6,
          max: 16,
          message: this.$t('tip.psdLenghtAlert'), // 长度限制
          trigger: 'blur',
        }],
      },
      timer: null,
    };
  },
  watch: {
    path: {
      handler(val) {
        if (val === 'forget' && !this.imageCode) {
          // 如果path字段设置为forget而没有图片验证码的时候获取图片验证码
          this.getImageCode();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 跳转到注册页面
    toRegister() {
      if (this.$route.path.indexOf('register') < 0) {
        this.cancel();
        this.$router.push('/register').catch(Function.prototype);
      } else {
        this.cancel();
      }
    },
    // 验证图片验证码
    verifyImageCode() {
      // 基本验证 图片验证码、手机号码有没有输入
      if (!this.restInfo.imageCode || !(this.restInfo.account.length === 11)) {
        return;
      }
      let actionName;
      const content = {};
      if (/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(this.restInfo.account)) {
        // 是否输入了邮箱
        actionName = 'candao.user.sendEmailVerficCode';
        content.email = this.restInfo.account;
      } else if (/^\d{11}$/.test(this.restInfo.account)) {
        // 是否输入了手机号
        content.phone = this.restInfo.account;
      } else {
        // 如果不能命中以上规则，则return
        return;
      }
      // 发送手机/邮箱验证码
      this.$service.verify.imageCodeVerify({ actionName, content, imgCode: this.restInfo.imageCode })
        .then(() => {
          // 倒计时开始
          this.createTime = new Date().getTime() + 60000;
          this.timer = setInterval(() => {
            this.createTime -= 1000;
            if (this.createTime - new Date().getTime() <= 0) {
              this.createTime = '';
              clearInterval(this.timer);
            }
          }, 1000);
        })
        .catch((err) => {
          // 提示用户
          this.$Message.error(err.msg || this.$t('tip.error.code'));
          // 重新获取验证码
          this.getImageCode();
        });
    },
    // 切换窗口
    toggle() {
      // 切换为不同于当前的窗口
      if (this.type === 'login') {
        // 获取验证码图片
        this.getImageCode();
        this.type = 'forget';
        this.$nextTick(() => {
          this.$refs.restInfo.resetFields();
        });
      } else {
        this.type = 'login';
      }
    },
    // 获取验证码图片
    getImageCode() {
      this.imageCode = `./ImageCodeAction?type=2&_${Date.parse(new Date())}`;
    },
    // 表单验证
    formValidate(name, callback) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          callback();
        }
      });
    },
    // 用户点击登录
    login() {
      const content = {
        loginKey: this.info.account,
        password: md5(this.info.password), // md5加密
      };
      this.showLoginLoading = true;
      this.$service.user.login.account({ content })
        .then(() => this.$service.user.getUserInfo())
        .then(() => {
          // 登录成功
          // this.$service.user.getUser().login(res.serverTime, res.data);
          // console.log(this.$parent.header === 'main-header', this.$parent.$refs.header.login);
          if (this.$parent.header === 'main-header') {
            // 判断父组件的main-header组件是否存在
            // 存在则更新值
            this.$parent.$refs.header.login();
            // this.$parent.$refs.header.isLogin = this.$service.user.getUser().check();
            // this.$parent.$refs.header.userName = this.$service.user.getUser().info.userName;
          }
          // this.isLogin = this.$service.user.getUser().check();
          // this.userName = this.$service.user.getUser().info.userName;
          if (this.$route.path.indexOf('register') > -1 && !this.callBackRoute) {
            this.$router.push('/').catch(Function.prototype);
          } else if (this.callBackRoute) {
            this.$router.push(this.callBackRoute).catch(Function.prototype);
          }
          this.cancel();
        })
        .catch((err) => {
          console.log(err);
          // 登录失败
          this.$Message.error(err.msg || '');
          this.$service.user.getUser().clear();
        })
        .finally(() => {
          this.showLoginLoading = false;
        });
    },
    // 使用手机验证码修改
    phonePwd() {
      const params = {};
      // 解构赋值
      ({
        account: params.phone,
        phoneCode: params.verificCode,
        newPsd: params.password,
      } = this.restInfo);
      params.password = md5(params.password);
      this.$service.user.password.phone({ content: params })
        .then(() => {
          // 修改成功
          this.$Modal.info({
            content: '重置密码成功，请重新登录',
            onOk: () => {
              if (!this.callBackRoute) {
                this.$router.replace(this.callBackRoute).catch(Function.prototype);
              } else {
                this.$router.replace('/').catch(Function.prototype);
              }
            },
            onCancel: () => {
              this.$router.replace('/').catch(Function.prototype);
            },
          });
          // this.$Message.success({ content: res.msg });
        })
        .catch((err) => { // 修改失败
          if (err.msg) {
            this.$Modal.info({
              content: err.msg,
            });
          }
          // this.$Message.error({ content: err.msg });
        })
        .finally(() => { // 关闭loading
          this.cancel();
        });
    },
    // 用户点击关闭弹框
    cancel() {
      this.is = false;
      this.$emit('update:show', false);
    },
  },
};

</script>

<style lang="sass" scoped>
.iview-label .ivu-form-item-label
  font-size: 12px
.login-header
  text-align: left
  font-size: 22px
  color: #0f9675
  height: auto
  font-weight: initial
.login-close-icon
  line-height: 34px
  color: #979797
  font-size: 21px
  font-weight: 700
  line-height: 1
  text-shadow: 0 1px 0 #fff
.login-footer
  margin-top: 24px
  text-align: center
  overflow: hidden
  .cd-btn
    padding: 6px 45px
  .footer-tip
    margin: 20px 0
    a
      color: #0f9675
.login-footer-forget
  margin-top: 0
  margin-bottom: 16px
.login-content-en
  padding: 0 20px
.login-content
  margin-top: 32px
  overflow: hidden
  .iview-input
    width: 285px
  .iview-input-code
    width: 190px
  .code-img
    height: 32px
    width: 90px
    vertical-align: top
    margin-left: 3px
  .iview-input-forget
    width: 173px
  .iview-input-forget-button
    margin-left: 8px
    min-width: 88px
  >p
    text-align: center
    overflow: hidden
    .iview-checkbox
      color: #7a7a7a
      padding-right: 27px
    span
      float: right
      padding-right: 18px
      a
        color: #0f9675
</style>
